export default "__VITE_ASSET__EmGqTO68__"